@use '@lib/assets/styles/main.scss' as *;

.sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 24px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chip {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 2px 6px;
  border-radius: 6px;
  background: $blueLight;
}

.chipLabel {
  color: $gray900;
}

.intro {
  display: flex;
  flex-direction: column;
}

.itemList {
  list-style: disc;
  margin: 0;
  padding: 0 0 0 22px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item {
  color: $gray900;
  &::marker {
    color: $gray900;
  }
}

.itemTitle {
  color: $gray900;
  display: inline;
}

.itemDescription {
  color: $gray700;
  display: block;
  margin-top: 0;
}
